import { useCallback, useContext } from "react";
import { useSelector } from "react-redux";
import { PaymentType } from "../../../common/payment/paymentType";
import { MenuDataLocaleContext } from "../../menudata/context/MenuDataLocaleContext";
import { getGuestPlatformFeeEnabled } from "../../order/selectors/restaurantFlags";
import { getProcessingFeeText } from "./getProcessingFeeText";

// Binds the venue's fee scheme once so every render site agrees. Venue-scoped, not
// per-payment: history and international cards can still differ from the server's label.
export const useProcessingFeeText = () => {
    const menuDataLocale = useContext(MenuDataLocaleContext);
    const guestPlatformFeeEnabled = useSelector(getGuestPlatformFeeEnabled);

    return useCallback(
        (paymentMethod?: PaymentType | string | null, feeLabel?: string | null) =>
            getProcessingFeeText(menuDataLocale, paymentMethod, { guestPlatformFeeEnabled, feeLabel }),
        [menuDataLocale, guestPlatformFeeEnabled]
    );
};
